import { queryOptions } from "@tanstack/react-query";
import { fetchLegacyMetricsSummary } from "./legacyMetrics.api";

export const legacyMetricsQueryKeys = {
  all: ["legacy-metrics"] as const,
  summary: () => [...legacyMetricsQueryKeys.all, "summary"] as const,
};

/** A 30-day rollup changes slowly; 5 minutes before a background refetch. */
const SUMMARY_STALE_TIME_MS = 5 * 60 * 1000;

export function legacyMetricsSummaryQueryOptions() {
  return queryOptions({
    queryKey: legacyMetricsQueryKeys.summary(),
    queryFn: fetchLegacyMetricsSummary,
    staleTime: SUMMARY_STALE_TIME_MS,
  });
}
